import tw from "twin.macro";
import { ArrowDirectionEnum } from "./enums/arrow-directon.enum";
import SwitchArrowDirectionIcon from "./switchs/switch-arrow-direction-icon";

function StepActionButton({
  disabled,
  actionTranslation,
  onClick,
  arrowDirection,
  skipStep,
  cancelButton,
}: {
  disabled: boolean;
  actionTranslation: string;
  onClick?: () => void;
  arrowDirection?: ArrowDirectionEnum;
  skipStep?: boolean;
  cancelButton?: boolean;
}) {
  return (
    <button
      css={[
        tw`w-full flex items-center gap-1 m-1 min-w-[130px]`,
        tw`bg-primary-800 text-white`,
        tw`shadow-md`,
        tw`active:scale-100 active:bg-gray-200/50 active:transition active:transform active:duration-100 active:text-primary-800`,
        tw`transition transform duration-100 flex items-center justify-around rounded-3xl min-h-[40px] p-1`,
        tw`disabled:opacity-40
          disabled:cursor-not-allowed
          disabled:active:scale-100`,
        // Promotion GPU pour éviter que iOS Safari ne recompose le `shadow-md`
        // à chaque frame quand le panel du BottomSheet anime son `translateY`
        // pendant l'ouverture/fermeture du sheet. Le shadow est "cuit" dans
        // la couche du bouton et le compositor se contente ensuite de
        // translater la couche entière → quasi gratuit côté GPU.
        { transform: "translateZ(0)" },
        (skipStep || cancelButton) &&
          tw`border border-gray-300 active:bg-gray-200 active:text-white`,
        (skipStep || cancelButton) && tw`bg-transparent`,
        (skipStep || cancelButton) && tw`text-gray-500`,
        (skipStep || cancelButton) && tw`shadow-none`,
      ]}
      disabled={disabled} //TODO gérer ici
      onClick={onClick ?? undefined}
    >
      <p css={[tw`text-lg font-normal min-w-[166px]`]}>{actionTranslation}</p>
      {arrowDirection && (
        <SwitchArrowDirectionIcon arrowDirection={arrowDirection} size={24} />
      )}
    </button>
  );
}

export default StepActionButton;
